import type { EffectCallback } from 'react'

import { useEffect } from 'react'

type Destructor = () => void

const useMount = (effect: EffectCallback) => useEffect(effect, [])
const useUnMount = (destructor: Destructor) => useMount(() => destructor)
export { useMount, useUnMount }
